import PropTypes from 'prop-types';

const DayHours = PropTypes.shape({
  open: PropTypes.string,
  close: PropTypes.string,
});

export const OpeningHours = PropTypes.shape({
  opening_hours: PropTypes.string,
  hours_by_day: PropTypes.shape({
    1: DayHours,
    2: DayHours,
    3: DayHours,
    4: DayHours,
    5: DayHours,
    6: DayHours,
    7: DayHours,
  }),
});

export default OpeningHours;
